import { render, staticRenderFns } from "./RegisterPotentialHouse.vue?vue&type=template&id=7adea83e&scoped=true&"
import script from "./RegisterPotentialHouse.vue?vue&type=script&lang=js&"
export * from "./RegisterPotentialHouse.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPotentialHouse.vue?vue&type=style&index=0&id=7adea83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adea83e",
  null
  
)

export default component.exports